import { IFreeTierLimits } from '../../innerhive-plus/revenue-cat/IFreeTierLimits';
import { ICaremapNote } from './NotesClient';
import { CaremapNotesModelFactory } from '../model/CaremapNotesModelFactory';

export class NoteFormTotalAttachmentCountHelper {

    // factory sets itself to avoid circular reference
    factory!:  CaremapNotesModelFactory;

    addAttachmentRequiresInnerhivePlus = (limits: IFreeTierLimits, noteBeingModified: ICaremapNote) => {

        const onAllOtherNotes = this.factory.forActiveCaremap().getAttachmentCount() - (this.factory.forActiveCaremap().getNote(noteBeingModified.noteId)?.attachments || []).length;

        const onThisNote = noteBeingModified.attachments.length;
        const uploading = this.factory.fileUploader.uploadingFiles.filter(f => !f.isUploaded).length;

        return onAllOtherNotes + onThisNote + uploading >= limits.freeAttachmentsPerCaremap;
    };
}
